/* @flow */

import React from 'react'
import { connect } from 'react-redux'

import type {
  RootState,
  CheckedoutPoll,
  PollTypeId,
  CustomerId,
  Action,
} from '../types'

import { fetchIconsIntoStore } from '../sagas/fetchIcons'
import {
  selectCheckedoutPoll,
  checkoutNewPoll,
} from '../stores/pollBuilderCheckedoutPoll'

import CheckedoutPollComponent from './CheckedoutPoll'

import { selectCurrentUser } from '../stores/currentUser'

type Props = {
  params: {
    pollTypeId: PollTypeId,
  },
  checkedoutPoll: ?CheckedoutPoll,
  customerId: ?CustomerId,
  checkoutNewPoll: (pollTypeId: PollTypeId, ?CustomerId) => void,
  fetchIconsIntoStore: () => Action,
}

type StateProps = {
  checkedoutPoll: ?CheckedoutPoll,
  customerId: ?CustomerId,
}

type DispatchProps = {
  checkoutNewPoll: (pollTypeId: PollTypeId) => Action,
  fetchIconsIntoStore: () => Action,
}

class NewPollPage extends React.Component<Props, StateProps> {
  componentDidMount() {
    // make sure we have the most recent icons to choose from
    this.props.fetchIconsIntoStore()
    this.props.checkoutNewPoll(
      this.props.params.pollTypeId,
      this.props.customerId
    )

    // TODO we should fetch the customers here
    // right now we depend on the customers extracted from the icons
  }

  componentWillReceiveProps(nextProps) {
    // Rerender if poll type changes
    if (this.props.params.pollTypeId !== nextProps.params.pollTypeId) {
      this.props.checkoutNewPoll(
        nextProps.params.pollTypeId,
        this.props.customerId
      )
    }
  }

  // this is used by flow to do static prop type checking
  // the trailing ; is required by flow
  props: Props

  render() {
    if (this.props.checkedoutPoll == null) {
      return null
    }
    return <CheckedoutPollComponent />
  }
}

function mapStateToProps(state: RootState): StateProps {
  const currentUser = selectCurrentUser(state)
  const customerId = currentUser ? currentUser.customerId : null

  return {
    checkedoutPoll: selectCheckedoutPoll(state),
    customerId,
  }
}

const mapDispatchToProps: DispatchProps = {
  fetchIconsIntoStore,
  checkoutNewPoll,
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(NewPollPage)



// WEBPACK FOOTER //
// ./src/components/NewPollPage.js